<template>
  <Container>
    <Title
      strong
      bold
    >
      {{ donationPeriod }}
    </Title>

    <Form>
      <FormCard>
        <BreadCrumb :items="breadCrumbitems" />
        <FormHeading>
          {{ steps.DONATION_AMOUNT }}
          <span v-if="donationAmount">$ {{ donationAmount }}</span>
        </FormHeading>

        <FormRow
          v-if="donationPeriod == donationPeriodType.DONATION_SINGLE"
        >
          <div class="btn-wrap">
            <ChosenButton
              :chosen="donationAmount == '500'"
              @click.native="chose('500')"
            >
              $500
            </ChosenButton>
            <ChosenButton
              :chosen="donationAmount == '1000'"
              @click.native="chose('1000')"
            >
              $1000
            </ChosenButton>
            <ChosenButton
              :chosen="donationAmount == '2000'"
              @click.native="chose('2000')"
            >
              $2000
            </ChosenButton>
            <ChosenButton
              :chosen="donationAmount == '5000'"
              @click.native="chose('5000')"
            >
              $5000
            </ChosenButton>
          </div>
        </FormRow>

        <FormRow
          v-if="donationPeriod == donationPeriodType.DONATION_PERIOD"
        >
          <div class="btn-wrap">
            <ChosenButton
              :chosen="donationAmount == '300'"
              @click.native="chose('300')"
            >
              $300
            </ChosenButton>
            <ChosenButton
              :chosen="donationAmount == '500'"
              @click.native="chose('500')"
            >
              $500
            </ChosenButton>
            <ChosenButton
              :chosen="donationAmount == '1000'"
              @click.native="chose('1000')"
            >
              $1000
            </ChosenButton>
            <ChosenButton
              :chosen="donationAmount == '2000'"
              @click.native="chose('2000')"
            >
              $2000
            </ChosenButton>
          </div>
        </FormRow>

        <FormRow>
          <template>
            <FormLabel for="donation-amount">
              自行輸入捐款金額
            </FormLabel>
            <TextInput
              id="donation-amount"
              data-testid="donation-amount"
              placeholder="請輸入台幣金額"
              :value.sync="donationAmount"
              :error="donationAmountError"
            />
          </template>
        </FormRow>

        <FormRow v-if="donationPeriod == donationPeriodType.DONATION_SINGLE">
          <template>
            <FormLabel for="donation-way">
              捐款方式
            </FormLabel>
            <SelectInput
              id="donation-way"
              :options="
                [
                  donationWayType.ECPAY_SINGLE_CREDIT,
                  donationWayType.ECPAY_SINGLE_ATM,
                  donationWayType.ECPAY_SINGLE_CVS,
                  donationWayType.LINEPAY_SINGLE,
                  donationWayType.JKOPAY_SINGLE,
                ]"
              :value.sync="donationWay"
              :error="donationWayError"
            />
          </template>
        </FormRow>

        <FormRow v-if="donationPeriod == donationPeriodType.DONATION_PERIOD">
          <template>
            <FormLabel for="donation-way">
              捐款方式
            </FormLabel>
            <SelectInput
              id="donation-way"
              :options="[donationPeriodType.ECPAY_PERIOD_CREDIT]"
              :value.sync="donationWay"
              :error="donationWayError"
            />
          </template>
        </FormRow>

        <br>
        <Align space-between>
          <Button
            back
            :small="isMobile"
            @click.native="back()"
          >
            上一步
          </Button>
          <Button
            :small="isMobile"
            @click.native="submit()"
          >
            下一步
          </Button>
        </Align>
      </FormCard>
    </Form>
  </Container>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
// configs
import steps from '@/configs/steps';
import donationPeriodType from '@/configs/donationPeriod';
import donationWayType from '@/configs/donationWay';
import { isValidString, isValidAmount, isValidOption } from '../../utilities/validators';
import { DONATION_WAY_TO_DONATION_GA_INFO } from '@/configs/GAconfig.js';
import { saveStore } from '@/lib/storage';

import Container from '../../components/layout/Container';
import Align from '../../components/layout/Align';
import Title from '../../components/Title';
import Form from '../../components/form/Form';
import FormCard from '../../components/form/FormCard';
import FormHeading from '../../components/form/FormHeading';
import FormLabel from '../../components/form/FormLabel';
import FormRow from '../../components/form/FormRow';

import Button from '../../components/buttons/Button';
import ChosenButton from '../../components/buttons/ChosenButton';

import TextInput from '../../components/inputs/TextInput';
import SelectInput from '../../components/inputs/SelectInput';

import BreadCrumb from '../../components/others/BreadCrumb';

export default {
  components: {
    Container,
    Align,

    Title,

    Form,
    FormCard,
    FormHeading,
    FormRow,
    FormLabel,

    ChosenButton,
    Button,

    TextInput,
    SelectInput,

    BreadCrumb,
  },

  data() {
    return {
      steps: Object.freeze(steps),
      donationPeriodType: Object.freeze(donationPeriodType),
      donationWayType: Object.freeze(donationWayType),
      donationAmountError: '',
      donationWayError: '',
    };
  },

  computed: {
    ...mapState({
      breadCrumbitems: state => state.breadCrumb.items,
    }),

    ...mapFields('donation', {
      donationPeriod: 'donationPeriod',
      donationWay: 'donationWay',
      donationAmount: 'amount',
      campaignId: 'campaignId',
    }),

    ...mapGetters('ui', [
      'isMobile',
    ]),

    valid() {
      return !this.donationAmountError && !this.donationWayError;
    },

  },

  mounted() {
    this.updateStep('0');
    this.donationPeriod = this.getDonationPeriod();
    this.getCampaignId();
    this.donationWay = this.donationPeriod == donationPeriodType.DONATION_PERIOD ? '信用卡定期定額' : '';
  },

  methods: {
    ...mapMutations({
      updateStep: 'breadCrumb/updateStep',
    }),

    ...mapActions('donation', [
      'validateCampaignId',
    ]),

    async getCampaignId() {
      const campaignId = this.$route.query.campaignId;
      const validate = campaignId ? await this.validateCampaignId(campaignId) : false;
      this.campaignId = validate ? campaignId : '';
    },

    checkForErrors() {
      if (!isValidString(this.donationAmount)) {
        this.donationAmountError = '請輸入捐款金額，並且不要使用全形符號、空格、或,+!?/()等符號。';
      }
      else if (!isValidAmount(this.donationAmount)) {
        this.donationAmountError = '請輸入正確的捐款金額';
      }
      else if (Number(this.donationAmount) < 100) {
        this.donationAmountError = '捐款金額需至少100元';
      }
      else if (this.donationWay == '信用卡單次繳款' && this.donationAmount > 200000) {
        this.donationAmountError = '信用卡付款單次捐款金額上限為 20 萬元，若欲捐款 20 萬元以上，建議分次填寫或採用其他捐款方式，謝謝！';
      }
      else if (this.donationWay == 'ATM轉帳繳款' && this.donationAmount > 200000) {
        this.donationAmountError = 'ATM 轉帳繳款單次捐款上限為 20 萬元，若欲捐款 20 萬元以上，建議分次填寫或採用其他捐款方式，謝謝！';
      }
      else if (this.donationWay == '超商代碼繳款' && this.donationAmount > 20000) {
        this.donationAmountError = '超商代碼繳款單次捐款上限為 2 萬元，若欲捐款 2 萬元以上，建議分次填寫或採用其他捐款方式，謝謝！';
      }
      else {
        this.donationAmountError = null;
      }

      if(this.donationPeriod === donationPeriodType.DONATION_SINGLE) {
        if(!isValidOption(this.donationWay)) {
          this.donationWayError = '請選擇捐款方式';
        }
        else {
          this.donationWayError = null;
        }
      }

    },

    // 當使用者直接從特定的url近來，會需要從url判斷捐款類型
    getDonationPeriod() {
      if (this.$route.name == 'period-amount') {
        return donationPeriodType.DONATION_PERIOD;
      } else if (this.$route.name == 'single-amount') {
        return donationPeriodType.DONATION_SINGLE;
      } else {
        return;
      }
    },

    back() {
      this.$router.push({ name: 'donation-way' });
    },

    sendGA() {
      const GA_DONATION_INFO = DONATION_WAY_TO_DONATION_GA_INFO[this.donationWay];
      const GA_PARM = {
        ecommerce: {
          currency: 'TWD',
          value: this.donationAmount,
          items: [GA_DONATION_INFO['item']],
        },
      };
      this.$gtag.event('TD_add_to_cart', GA_PARM);
      console.log('TD_add_to_cart', GA_PARM);
    },

    submit() {
      saveStore();
      this.checkForErrors();
      if(this.valid) {

        this.sendGA();
        this.$router.push({ name: this.donationPeriod === donationPeriodType.DONATION_SINGLE ? 'single-info' : 'period-info' });
      }
    },

    chose(data) {
      this.donationAmount = data;
    },
  },
};

</script>

<style lang="scss">
.btn-wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > button {
    margin: 5px 0;
  }
}

.text {
  font-size: 1.4rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: 0.8px;
  color: $color-text;
  margin: 10px auto 10px;
}
</style>

<style lang="scss" module>
.text {
  font-size: 1.2rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: 0.8px;
  color: $color-text;
  margin: 10px auto 10px;
}
</style>

